import { createContext } from 'react'

export const ScreenContext = createContext( {} )